'use client';

import React, { useEffect } from 'react';
import { App } from '../../constants';
import { Box } from '../../wag-react/next-components/box';
export type InstagramPostEmbedProps = {
  /**
   * Embed Code from the Instagram Post
   * To retrieve the Embed Code from an Instagram Post, visit https://help.instagram.com/620154495870484/
   * for more info
   */
  value: string;
};
export const InstagramPostEmbed = ({
  value
}: InstagramPostEmbedProps) => {
  useEffect(() => {
    if (!window || !window[App.InstagramWindowKey]) {
      return;
    }
    if (!window[App.InstagramWindowKey].Embeds.process) {
      return;
    }

    /**
     * Call this function safely so that the Instagram Post
     * will be initialized. Without this, the Instagram Post
     * element would be on a loading state
     */
    window[App.InstagramWindowKey].Embeds.process();
  }, []);
  return <Box display="flex" justifyContent="center" dangerouslySetInnerHTML={{
    __html: value
  }} data-sentry-element="Box" data-sentry-component="InstagramPostEmbed" data-sentry-source-file="index.tsx" />;
};